import About from "@/components/About";
import Team from "@/components/Team";

export default function AboutPage() {
  return (
    <div className="pt-16 lg:pt-20" data-testid="about-page">
      <About />
      <Team />
    </div>
  );
}
